import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

(async () => {
  // 'pk_live_51K73SLEPPd6Va1hokSdPuahwAwsr8c2OnGSpHO5TShiGxeIkk5qarUUhgCO4oTA28Dm5rMItsFTWlf8chS0mKDiv00Uno5RAOo'
  // 'pk_test_51K73SLEPPd6Va1hoPjlAmBHrvQJZpPDTgvFCXJpAPnkzYLsZavPC1xrdv6CJvXNJ9UXqNfV5QUAPbgY5i3Z3qxvQ008ezAzvSZ'
  const stripePromise = loadStripe(
    'pk_live_51K73SLEPPd6Va1hokSdPuahwAwsr8c2OnGSpHO5TShiGxeIkk5qarUUhgCO4oTA28Dm5rMItsFTWlf8chS0mKDiv00Uno5RAOo'
  );
  ReactDOM.render(
    <React.StrictMode>
      <Elements stripe={stripePromise}>
        <App />
      </Elements>
    </React.StrictMode>,
    document.getElementById('root')
  );
})();
